<div
  class="language-dropdown"
  [ngClass]="dropdownClass"
  appDisableLightTheme
  [enableLightTheme]="enableLightTheme"
>
  <button class="language-dropdown__button" (click)="toggleMenu($event)">
    <app-svg-icon
      [icon]="'assets/images/flags/' + selectedLanguage + '.svg'"
      [blank]="true"
      class="language-dropdown__flag"
    />
    <span class="language-dropdown__label">{{ selectedLanguage | uppercase }}</span>
    <app-svg-icon
      class="language-dropdown__icon"
      [class.language-dropdown__icon--reverse]="isMenuOpen"
      [icon]="'assets/images/language-dropdown/chevron.svg'"
      [blank]="true"
    />
  </button>

  @if (isMenuOpen) {
    <div class="language-dropdown__panel" [class.language-dropdown__panel--above]="openAbove">
      @for (lang of availableLanguages; track lang.code) {
        <button class="language-dropdown__item" (click)="changeLanguage(lang.code)">
          <app-svg-icon [icon]="'assets/images/flags/' + lang.code + '.svg'" [blank]="true" />
          {{ lang.code | uppercase }}
        </button>
      }
    </div>
  }
</div>
